import { search } from "../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/faturamento/tipocontratos/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export const indexTypeContractByCompany = async ({
  empresa_cnpj,
  empresa_id,
  where = {},
}) => {
  let queryWhere = "";
  Object.keys(where).forEach((key) => {
    queryWhere += `&where[${key}]=${where[key]}`;
  });

  return search(
    `${path}/getporempresa/${empresa_id}?empresa_cnpj=${empresa_cnpj}${queryWhere}`,
    "GET",
    headers
  );
};

export const getTipoContratoLists = async ({ empresa_cnpj }) =>
  search(`${path}/getlistas?empresa_cnpj=${empresa_cnpj}`, "GET", headers);

export const createTipoContrato = async ({ body, empresa_cnpj }) =>
  search(`${path}?empresa_cnpj=${empresa_cnpj}`, "POST", headers, body);

export const getTipoContrato = async ({ id, empresa_cnpj, include }) =>
  search(
    `${path}${id ? `/${id}` : ""}?empresa_cnpj=${empresa_cnpj}${
      include ? `&include=${include}` : ""
    }`,
    "GET",
    headers
  );

export const updateTipoContrato = async ({ id, body, empresa_cnpj }) =>
  search(`${path}/${id}?empresa_cnpj=${empresa_cnpj}`, "PUT", headers, body);
